package org.vreo.devicehub.features.vrmOutput.presentation.components

import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.vrmOutput.domain.models.VrmOverlayerPosition

import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.vrm_position_label_bottom_left
import devicehub.composeapp.generated.resources.vrm_position_label_bottom_right
import devicehub.composeapp.generated.resources.vrm_position_label_top_left
import devicehub.composeapp.generated.resources.vrm_position_label_top_right

/**
 * Convert [VrmOverlayerPosition] to [UiText].
 *
 * @return [UiText] on success, error otherwise
 */
fun VrmOverlayerPosition.toUiText(): UiText {
    val stringRes = when (this) {
        VrmOverlayerPosition.TOP_LEFT -> Res.string.vrm_position_label_top_left
        VrmOverlayerPosition.TOP_RIGHT -> Res.string.vrm_position_label_top_right
        VrmOverlayerPosition.BOTTOM_LEFT -> Res.string.vrm_position_label_bottom_left
        VrmOverlayerPosition.BOTTOM_RIGHT -> Res.string.vrm_position_label_bottom_right
    }

    return UiText.StringResourceId(stringRes)
}